export default __webpack_public_path__ + "static/media/account-admin.0098e19f.svg";